import type { ComponentProps, ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface VisuallyHiddenProps extends ComponentProps<'div'> {
  children: ReactNode;
}

/**
 * VisuallyHidden component for accessibility.
 * Hides content visually while keeping it available to screen readers.
 * Use this to wrap DialogTitle when you want to hide it visually but keep it accessible.
 */
function VisuallyHidden({ children, className, ...props }: VisuallyHiddenProps) {
  return (
    <div className={cn('sr-only', className)} {...props}>
      {children}
    </div>
  );
}

export { VisuallyHidden };
